import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { buildWhatsAppUrl, defaultEnquiryMessage } from "@/utilities/whatsapp";
import { trackEvent, AnalyticsEvents } from "@/utilities/analytics";

/**
 * Floating WhatsApp — desktop bottom-right, sticky bottom band on mobile.
 */
export default function FloatingWhatsApp() {
    const [visible, setVisible] = useState(false);
    const href = buildWhatsAppUrl(defaultEnquiryMessage);
    useEffect(() => {
        const t = setTimeout(() => setVisible(true), 400);
        return () => clearTimeout(t);
    }, []);
    if (!visible) return null;
    return (
        <>
            {/* Desktop floating button */}
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Contact Container Specialist on WhatsApp"
                onClick={() =>
                    trackEvent(AnalyticsEvents.WHATSAPP_CLICK, { source: "floating-desktop" })
                }
                className="hidden md:inline-flex fixed bottom-6 right-6 z-40 items-center gap-3 bg-[#25D366] hover:bg-[#1eb055] text-white pl-3 pr-5 py-3 shadow-[0_10px_30px_rgba(0,0,0,0.25)] border border-[#25D366] transition-colors group"
                data-testid="floating-whatsapp-desktop"
            >
                <span className="w-9 h-9 inline-flex items-center justify-center bg-white/15">
                    <MessageCircle size={20} strokeWidth={2} />
                </span>
                <span className="font-mono uppercase tracking-widest text-xs">WhatsApp Us</span>
            </a>

            {/* Mobile sticky bottom CTA */}
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Contact Container Specialist on WhatsApp"
                onClick={() =>
                    trackEvent(AnalyticsEvents.WHATSAPP_CLICK, { source: "floating-mobile" })
                }
                className="md:hidden fixed inset-x-0 bottom-0 z-40 flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1eb055] text-white py-3 border-t border-[#1eb055] shadow-[0_-8px_24px_rgba(0,0,0,0.18)]"
                data-testid="floating-whatsapp-mobile"
            >
                <MessageCircle size={18} strokeWidth={2} />
                <span className="font-mono uppercase tracking-[0.22em] text-xs">
                    WhatsApp Container Specialist
                </span>
            </a>
        </>
    );
}
